import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobProgressionViewModel from '../JobProgressionViewModel'
import TaxExtensionProgressionActions from '../TaxExtensionProgressionActions'

interface Props {
  vm: JobProgressionViewModel
}
export default observer(function DraftRejectedProgressionActions({
  vm,
}: Props) {
  return (
    <>
      <CardContent compactBottomPadding>
        <Button
          type="secondary"
          size="wide-slim"
          onClick={vm.openItemsDialogVM.show}
          dataTest="job-progression-set-open-items-button"
        >
          Report Open Items
        </Button>
      </CardContent>
      <CardContent compactBottomPadding={vm.isAnyExtensionFlowAvailable}>
        <Button
          type="primary"
          size="wide-slim"
          onClick={() => vm.answerDraftInReview()}
          dataTest="job-progression-set-draft-in-review-button"
        >
          Request Draft Approval
        </Button>
      </CardContent>

      {vm.isAnyExtensionFlowAvailable && (
        <TaxExtensionProgressionActions vm={vm} isSecondary />
      )}
    </>
  )
})
